import { toggleMenuCaptions as toggleMenuCaptionsActionType } from "../types"

export default function toggleMenuCaptions() {
  return {
    type: toggleMenuCaptionsActionType,
  }
}
